import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { loadCenter, loadCenterMaps } from '@app/actions/system/center.action';
import { CenterModel } from '@app/models/system/center.model';
import { CenterState, getCentersMaps } from '@app/selectors/system/center.selector';
import { Loader } from '@googlemaps/js-api-loader';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import {ValidationUtil} from "@app/common/util/validation.util";

declare var kakao: any;

@Component({
  selector: 'app-plus-map',
  templateUrl: './plus-map.component.html',
  styleUrls: ['./plus-map.component.css']
})
export class PlusMapComponent implements OnInit {
  centerMaps$ = new Observable<CenterModel[]>;
  centerMaps: CenterModel[] = [];

  filteredLocations: any[] = [];

  searchQuery: string = '';
  isComposing: boolean = false;

  timeout: any;

  defaultAddr: string = "서울특별시 영등포구 양평로 144 (양평동5가)";

  constructor(
    private _centerStore: Store<CenterState>,
    private cdRef: ChangeDetectorRef
  ) {
    this.centerMaps$ = this._centerStore.select(getCentersMaps);
  }

  ngOnInit(): void {
    this._centerStore.dispatch(loadCenterMaps());

    this.centerMaps$.subscribe(res => {
      if(ValidationUtil.isNotNullAndNotEmpty(res)) {
        this.filteredLocations = res;
        this.centerMaps = res;
      };
      
    });

    setTimeout(() => {
      if (typeof kakao !== "undefined" && kakao.maps) {
        this.loadMap(this.defaultAddr);
      } else {
        console.warn("Kakao Maps SDK chưa load xong");
      }
    }, 500);
  }

  selectPlace(item: CenterModel): void {
    this.loadMap(item.addr1);
  }

  loadMap(address: String): void {
    const container = document.getElementById('map');

    const options = {
      center: new kakao.maps.LatLng(37.5665, 126.9780),
      level: 3
    };

    const map = new kakao.maps.Map(container, options);

    const geocoder = new kakao.maps.services.Geocoder();

    geocoder.addressSearch(address, (result:any, status:any) => {
      if (status === kakao.maps.services.Status.OK) {
        const coords = new kakao.maps.LatLng(result[0].y, result[0].x);

        map.setCenter(coords);

        const marker = new kakao.maps.Marker({
          map: map,
          position: coords
        });

        const infowindow = new kakao.maps.InfoWindow({
          content: `<div style="padding:5px;">${address}</div>`
        });
        infowindow.open(map, marker);
      } else {
        alert('주소를 찾을 수 없습니다!');
      }
    });
  }

  protected readonly ValidationUtil = ValidationUtil;

  onInput(event: Event) {
    console.log((event.target as HTMLInputElement).value)
    const query = (event.target as HTMLInputElement).value;
    this.filterLocations(query);
  }

  onCompositionStart() {
    this.isComposing = true;
  }

  onCompositionEnd(event: Event) {
    this.isComposing = false;
    const query = (event.target as HTMLInputElement).value;
    this.filterLocations(query);

    this.cdRef.detectChanges();
  }

  onCompositionUpdate(event: Event) {
    if (this.isComposing) {
      const query = (event.target as HTMLInputElement).value;
      this.filterLocations(query);
    }
  }

  filterLocations(query: string) {
    const normalizedQuery = query.trim().normalize('NFC');
    this.filteredLocations = this.centerMaps.filter(location =>
      location.cntName?.normalize('NFC').includes(normalizedQuery)
    );
  }
}
